module.exports = __webpack_public_path__ + "static/media/passo4.26f54b0b.jpg";